import { render, staticRenderFns } from "./SmsCenter.vue?vue&type=template&id=05fe5564&"
import script from "./SmsCenter.vue?vue&type=script&lang=js&"
export * from "./SmsCenter.vue?vue&type=script&lang=js&"
import style0 from "./SmsCenter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SmsCenter.vue"
export default component.exports